import { z } from 'zod';

const StatusEstadiaClienteEnum = z.enum([
  'em_transito',
  'em_homologacao',
  'pronta_aguardando_destino',
  'encerrada',
]);

const MotivoEncerramentoEstadiaEnum = z.enum(['enviado_ao_colaborador', 'retornado_para_raro', 'cancelado']);

const TipoChamadoClienteEstadiaEnum = z.enum(['homologacao_estoque', 'retirada_configuracao']);

const ProcessoMovimentacaoEnum = z.enum(['homologacao', 'remocao_imagem', 'devolucao_ao_cliente']);

const MetodoEntregaEnum = z.enum(['correios', 'uber', 'pessoalmente', 'outro']);

const AuditoriaAtorSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  avatar: z.string().nullable().optional(),
});

const ChamadoClienteEstadiaSchema = z.object({
  id: z.string().min(1),
  tipo: TipoChamadoClienteEstadiaEnum,
  numero: z.string().nullable().optional(),
  dataAbertura: z.any(),
  abertoPor: AuditoriaAtorSchema,
});

export const EstadiaClienteCreateSchema = z.object({
  equipamentoId: z.string().min(1, 'O equipamento é obrigatório'),
  clienteId: z.string().min(1, 'O cliente é obrigatório'),
  status: StatusEstadiaClienteEnum.optional(),
  motivo: ProcessoMovimentacaoEnum,
  colaboradorCotadoId: z.string().nullable().optional(),
  chamados: z.array(ChamadoClienteEstadiaSchema).optional(),
  formaEnvio: MetodoEntregaEnum.nullable().optional(),
  codigoRastreio: z.string().nullable().optional(),
  dataEnvioRaro: z.any().nullable().optional(),
  dataChegadaCliente: z.any().nullable().optional(),
  dataPrevistaRetirada: z.any().nullable().optional(),
  observacoes: z.string().nullable().optional(),
  createdBy: AuditoriaAtorSchema,
});

export const EstadiaClienteUpdateSchema = z.object({
  id: z.string().min(1, 'O ID da estadia é obrigatório'),
  status: StatusEstadiaClienteEnum.optional(),
  motivoEncerramento: MotivoEncerramentoEstadiaEnum.nullable().optional(),
  motivo: ProcessoMovimentacaoEnum.optional(),
  colaboradorCotadoId: z.string().nullable().optional(),
  chamados: z.array(ChamadoClienteEstadiaSchema).optional(),
  formaEnvio: MetodoEntregaEnum.nullable().optional(),
  codigoRastreio: z.string().nullable().optional(),
  dataEnvioRaro: z.any().nullable().optional(),
  dataChegadaCliente: z.any().nullable().optional(),
  dataPrevistaRetirada: z.any().nullable().optional(),
  dataRecolhimento: z.any().nullable().optional(),
  formaRecolhimento: MetodoEntregaEnum.nullable().optional(),
  codigoRastreioRecolhimento: z.string().nullable().optional(),
  dataEncerramento: z.any().nullable().optional(),
  observacoes: z.string().nullable().optional(),
  updatedBy: AuditoriaAtorSchema.nullable().optional(),
});

export const EstadiaClienteSchema = z.object({
  id: z.string().min(1),
  equipamentoId: z.string().min(1),
  clienteId: z.string().min(1),
  status: StatusEstadiaClienteEnum,
  motivoEncerramento: MotivoEncerramentoEstadiaEnum.nullable().optional(),
  motivo: ProcessoMovimentacaoEnum,
  colaboradorCotadoId: z.string().nullable().optional(),
  chamados: z.array(ChamadoClienteEstadiaSchema),
  formaEnvio: MetodoEntregaEnum.nullable().optional(),
  codigoRastreio: z.string().nullable().optional(),
  dataEnvioRaro: z.any().nullable().optional(),
  dataChegadaCliente: z.any().nullable().optional(),
  dataPrevistaRetirada: z.any().nullable().optional(),
  dataRecolhimento: z.any().nullable().optional(),
  formaRecolhimento: MetodoEntregaEnum.nullable().optional(),
  codigoRastreioRecolhimento: z.string().nullable().optional(),
  dataEncerramento: z.any().nullable().optional(),
  solicitacaoRealId: z.string().nullable().optional(),
  movimentacaoRealId: z.string().nullable().optional(),
  observacoes: z.string().nullable().optional(),
  createdBy: AuditoriaAtorSchema,
  updatedBy: AuditoriaAtorSchema.nullable().optional(),
  createdAt: z.any(),
  updatedAt: z.any(),
});
